import { useState, useEffect } from 'react'

export interface SbpBank {
  bankName: string
  logoURL: string
  schema?: string
}

interface SbpBanksResponse {
  dictionary?: SbpBank[]
}

let cachedBanks: SbpBank[] | null = null

export async function fetchSbpBanks (): Promise<SbpBank[]> {
  if (cachedBanks) {
    return cachedBanks
  }

  try {
    const response = await fetch('https://qr.nspk.ru/proxyapp/c2bmembers.json')
    const data: SbpBanksResponse = await response.json()
    
    if (data?.dictionary) {
      cachedBanks = data.dictionary
      return cachedBanks
    }
  }
  catch (error) {
    console.error('Error fetching SBP banks:', error)
  }

  return []
}

export function useSbpBanks () {
  const [ banks, setBanks ] = useState<SbpBank[]>([])
  const [ loading, setLoading ] = useState(true)

  useEffect(() => {
    fetchSbpBanks()
      .then(setBanks)
      .finally(() => setLoading(false))
  }, [])

  return { banks, loading }
}

export function findSbpBankById (banks: SbpBank[], bankId: string): SbpBank | undefined {
  // bankId может быть схемой банка или частью названия
  return banks.find(bank => 
    bank.schema === bankId || 
    bank.bankName.toLowerCase().includes(bankId.toLowerCase())
  )
}
